import React from "react"

import "./legal-content.scss"
import HeaderLegal from "../../molecules/header-legal/header-legal"
import GeneralDescriptionLegal from "../../molecules/general-description-legal/general-description-legal"
import CollapseMenu from "../../molecules/collapse-menu/collapse-menu"

const LegalContent = ({ info }) => {
  return (
    <div className="f-legal-content ">
      <HeaderLegal colorBanner={info.colorBanner} title={info.titulo} />
      <GeneralDescriptionLegal mainDescription={info.descripcionGeneral} slug={info.slug} productos={info.tablaDeProductos} continuacionDescripcion={info.continuacionDescripcion} />
      {info.desplegables &&
        <CollapseMenu options={info.desplegables} slug={info.slug} />
      }
    </div>
  )
}

export default LegalContent
